module.exports = __webpack_public_path__ + "static/media/liten.cd9d5d08.mp3";